import React, {useEffect} from 'react';
import {Button} from "react-bootstrap";
import ReactGA from "react-ga";

const Features = () => {
    useEffect(() => {
        ReactGA.initialize('G-0FEQG8PQKQ');
        ReactGA.pageview(window.location.pathname);
    }, []);
    const handleClickProgram = () => {
        ReactGA.event({
            category: 'Button',
            action: 'Click',
            label: 'Ver programa'
        });
    }
    const handleClickApply = () => {
        ReactGA.event({
            category: 'Button',
            action: 'Click',
            label: 'Inscribete aqui'
        });
    }
    return (
        <>
            <div className='px-4 mx-auto sm:max-w-xl md:max-w-full  md:px-24 lg:px-8 bg-fuchsia-900'>
                <div className='px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20 -mt-20'>
                    <div className='max-w-xl mb-10 md:mx-auto sm:text-center lg:max-w-2xl md:mb-12'>
                        <h2 className='max-w-lg mb-6 font-sans text-3xl font-bold leading-none tracking-tight text-gray-900 sm:text-4xl md:mx-auto' id='agenda'>
                          <span className='relative inline-block'>
                            <span className='relative text-white'>ACTIVIDADES Y OFERTAS</span>
                          </span>{' '}
                        </h2>
                    </div>
                    <div className='grid row-gap-8 sm:row-gap-0 sm:grid-cols-2 lg:grid-cols-4'>
                        <div className='p-8'>
                            <div className='max-w-md text-center'>
                                <div className='flex items-center justify-center'>
                                    <img src='/assets/ilustraciones/svg/clases_magistrales.svg' alt='clases magistrales'/>
                                </div>
                                <h6 className='mb-2 font-semibold leading-5 text-white'>CLASES<br/>MAGISTRALES</h6>
                            </div>
                        </div>
                        <div className='p-8'>
                            <div className='max-w-md text-center'>
                                <div className='flex items-center justify-center'>
                                   <img src='/assets/ilustraciones/svg/talleres_experienciales.svg' alt='talleres experienciales'/>
                                </div>
                                <h6 className='mb-2 font-semibold leading-5 text-white'>TALLERES<br/>EXPERIENCIALES</h6>
                            </div>
                        </div>
                        <div className='p-8'>
                            <div className='max-w-md text-center'>
                                <div className='flex items-center justify-center'>
                                    <img src='/assets/ilustraciones/svg/talleres_de_extension.svg' alt='talleres extension culturales'/>
                                </div>
                                <h6 className='mb-2 font-semibold leading-5 text-white'>TALLERES<br/>EXTENSIÓN CULTURAL</h6>
                                <h6 className='text-white '>(Origami, Ilustración, Yoga, Huertos)</h6>
                            </div>
                        </div>
                        <div className='p-8'>
                            <div className='max-w-md text-center'>
                                <div className='flex items-center justify-center'>
                                    <img src='/assets/ilustraciones/svg/talleres_funcionarios.svg' alt='talleres para funcionarios municipales'/>
                                </div>
                                <h6 className='mb-2 font-semibold leading-5 text-white'>TALLERES PARA<br/>FUNCIONARIOS/AS<br/>PÚBLICOS</h6>
                            </div>
                        </div>
                        <div className='p-8'>
                            <div className='max-w-md text-center'>
                                <div className='flex items-center justify-center'>
                                    <img src='/assets/ilustraciones/svg/noches_tematicas.svg' alt='noches artisticas tematicas'/>
                                </div>
                                <h6 className='mb-2 font-semibold leading-5 text-white'>NOCHES ARTÍSTICAS TEMÁTICAS</h6>
                                <h6 className='text-white '>(Latinoamérica, Boleros, Urbana, Soul&Gospel, Chingana)</h6>
                            </div>
                        </div>
                        <div className='p-8'>
                            <div className='max-w-md text-center'>
                                <div className='flex items-center justify-center'>
                                    <img src='/assets/ilustraciones/svg/muestra_patrimonial.svg' alt='muestras y actividades patrimoniales'/>
                                </div>
                                <h6 className='mb-2 font-semibold leading-5 text-white'>MUESTRAS Y ACTIVIDADES PATRIMONIALES</h6>
                            </div>
                        </div>
                        <div className='p-8'>
                            <div className='max-w-md text-center'>
                                <div className='flex items-center justify-center'>
                                    <img src='/assets/ilustraciones/svg/artes_y_oficio.svg' alt='feria de artes y oficios'/>
                                </div>
                                <h6 className='mb-2 font-semibold leading-5 text-white'>FERIA DE ARTES<br/> Y OFICIOS</h6>
                            </div>
                        </div>
                        <div className='p-8'>
                            <div className='max-w-md text-center'>
                                <div className='flex items-center justify-center'>
                                    <img src='/assets/ilustraciones/svg/congreso_del_futuro.svg' alt='congreso del futuro universidad de ohggins'/>
                                </div>
                                <h6 className='mb-2 font-semibold leading-5 text-white'>CONGRESO FUTURO UNIVERSIDAD DE O'HIGGINS</h6>
                            </div>
                        </div>
                    </div>
                    <div className='grid grid-cols-1'>
                        <Button
                            onClick={handleClickProgram}
                            href='https://drive.google.com/drive/folders/1CiavIXON8OsZNCxceoBvLqCxtAJTlkH6'
                            target='_blank'
                            rel='noreferrer'
                            className='mx-auto lg:px-8 px-4 py-4 font-medium text-xl tracking-wide text-black capitalize bg-white transition-colors duration-300 transform rounded-lg mt-12 w-64 hover:bg-celeste_rancagua transition-colors duration-300'
                        >
                            VER PROGRAMA
                        </Button>
                        <Button
                            onClick={handleClickApply}
                            href='/inscripciones'
                            rel='noreferrer'
                            className='mx-auto lg:px-8 px-4 py-4  hover:bg-celeste_rancagua lg:px-8 px-4 py-4 font-medium text-2xl tracking-wide text-white capitalize transition-colors duration-300 transform bg-naranjo_rancagua rounded-lg mt-5 font-bold'
                        >
                            INSCRÍBETE AQUÍ
                        </Button>
                    </div>
                </div>
                <img src='/assets/ilustraciones/edit/11.svg' alt='' className='w-96 h-48 ml-auto -mt-48'/>
            </div>
        </>
    );
};

export default Features;